/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "How can I override styles with higher specificity?"
    }), "\n", _jsxs(_components.p, {
      children: ["The way to override styles with a high specificity is to simply increase the specificity of your own styles. This could be done using ", _jsx(_components.code, {
        children: "!important"
      }), ", but that's error prone and generally not a good idea."]
    }), "\n", _jsx(_components.p, {
      children: "We recommend the following technique:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const MyStyledComponent = styled(AlreadyStyledComponent)`\n  &&& {\n    color: #BF4F74;\n    font-weight: bold;\n  }\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Each ", _jsx(_components.code, {
        children: "&"
      }), " gets replaced with the generated class, so the injected CSS then looks like this:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: ".MyStyledComponent-asdf123.MyStyledComponent-asdf123.MyStyledComponent-asdf123 {\n  color: #BF4F74;\n  font-weight: bold;\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "The repeated class bumps the specificity high enough to override the source order without being very tedious to write!"
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
